import { render } from "./Example5.vue?vue&type=template&id=f1b3428e&scoped=true&ts=true"
import script from "./Example5.vue?vue&type=script&lang=ts"
export * from "./Example5.vue?vue&type=script&lang=ts"

import "./Example5.vue?vue&type=style&index=0&id=f1b3428e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b3428e"]])

export default __exports__